<template>
  <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }" class="field__item">
    <div class="field__item--label">
      <!--<label :class="[{'text&#45;&#45;red': errors.length > 0}, {'required': required}]" :for="name">
        {{ label }}
      </label>-->
    </div>
    <div :class="{'input__group--red': errors.length > 0}" class="field__item--textarea flex">
      <span ref="label" class="dynamic-label" :class="{ 'focused' : shouldHaveFocused}">{{ label }}</span>
      <textarea :id="name" @focus="focused = true" @blur="focused = false" :name="name" :type="type"
                :value="value" @keyup.stop @input="$emit('input', $event.target.value)"/>
    </div>
    <span :class="{'form__notice--active': errors.length > 0}" class="form__notice text--red">{{ errors[0] }}</span>
    <span class="form__notice form__notice--active text--light">
      <slot name="helper-text"></slot>
    </span>
    <slot name="hint"></slot>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'TextAreaField',
  props: {
    label: String,
    name: String,
    rules: String,
    type: String,
    value: {},
    classes: {},
    required: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      focused: false
    }
  },
  computed: {
    shouldHaveFocused () {
      if (this.focused) {
        return true
      }

      return this.value === null ? false : !!(typeof this.value !== 'undefined' && this.value !== '')
    }
  },
  methods: {
    changeValue: function (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
